import { render, staticRenderFns } from "./YTDRecord.vue?vue&type=template&id=328b12ef&scoped=true&"
import script from "./YTDRecord.vue?vue&type=script&lang=js&"
export * from "./YTDRecord.vue?vue&type=script&lang=js&"
import style0 from "./YTDRecord.vue?vue&type=style&index=0&id=328b12ef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b12ef",
  null
  
)

export default component.exports